import { AddNewPolicyReqMdl } from './AddNewPolicyReqMdl';
import { MotorStatusMdl } from './MotorStatusMdl';
export class ProposalModel {
    public ProposalNo: string;
    public ProposalFrom: string;
    public ProposalTo: string;
    public Name: string;
    public TotalPremium: number;
    public Status: string;
    public proposalFileName: string;
    public PolicyCardFileName: string;
    public PaymentStatus: number;
    public Mobile: string;
    public Email: string;
    public isUnderWriter: string;
    public EProposalNo: string;
    public PaySig: string;
    public EPayInfo: string;
    public ProductCode: string;
    public ProductDesc: string;
    public ProposalType: string;
    // public DownLoadProposal: string;
    public myProObj: ProposalInfoModel = new ProposalInfoModel();
    public transObj: TransInfoModel = new TransInfoModel();
    public newPolicyObj: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
    public cancelObj: MotorCancelProposal = new MotorCancelProposal();
    public isActive: boolean;

    isProposalEdit: boolean;
    public SadadBillNo: string;
    public SadadBillExp: string;

    public DownLoadProposal_Tpl: string;
    public DownLoadProposal_Comp: string;

    public TPLTotalPremium: number;
    public CompTotalPremium: number;
    public IsTplComplete: number;
    public IsCompComplete: number;


}
export class ProposalInfoModel {

    public EncProposalNo: string;

}

export class TransInfoModel {
    public RegNo: string;
    public ProposalNo: string;

    public InsuredName: string;
    public Premium: string;

    public ProductCode: string;

    public Email: string;
    public Mobile: string;

    public merchantRefNum: string;
    public OLPID: string;

    public TransDate: string;
    public st: MotorStatusMdl = new MotorStatusMdl();

    public isUnderwriter: boolean;
    public uploadNo: string;

    public PMethod: string;
    public EProposalNo: string;

    public EPayInfo: string;
    public PaySig: string;

    public IBAN: string;
    public BankCode: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;





}
export class MotorCancelProposal {
    public RegNo: string;
    public ProposalNo: string;
}
export class mdlProposalCancelReq_DH {
    public RegNo: string;
    public ProposalNo: string;
}
export class PayfortTransInfoModel {
    public RegNo: string;
    public ProposalNo: string;

    public InsuredName: string;
    public Premium: string;

    public ProductCode: string;

    public Email: string;
    public Mobile: string;

    public merchantRefNum: string;
    public OLPID: string;

    public TransDate: string;
    public st: MotorStatusMdl = new MotorStatusMdl();

    public isUnderwriter: boolean;
    public uploadNo: string;

    public PMethod: string;
    public EProposalNo: string;

    public EPayInfo: string;
    public PaySig: string;

    public IBAN: string;
    public BankCode: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;





}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/ProposalModel.ts